import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import avatar from "../../Assets/Home/prof_zhao.jpg";
import googleScholar from "../../Assets/Home/icons8-google-scholar-14.svg";

function Introduction() {
    return (
        <Container fluid className="home-about-section" id="introduction">
            <Container>
                <Row className="align-items-center" style={{ minHeight: "75vh" }}>
                    <Col md={8} xs={12} className="home-about-description">
                        <h1 style={{ fontSize: "2.6em" }}>
                            ABOUT <span className="purple"> DR. XIAOXU ZHAO </span>
                        </h1>
                        <p className="home-about-body">
                            Dr. Xiaoxu Zhao is a Principal Investigator and Ph.D. supervisor in the School of Materials Science and Engineering at Peking University. He received his B.Eng. degree with First Class Honours from Nanyang Technological University in 2014 and obtained his Ph.D. degree from National University of Singapore in 2018. From 2018 to 2022, he conducted postdoctoral research at the National University of Singapore and Nanyang Technological University, supported by the prestigious Presidential Postdoctoral Fellowship. <br />
                            Dr. Zhao joined Peking University in 2022 and currently leads research in low-dimensional quantum materials, advanced electron microscopy, and AI-driven high-resolution imaging and automated microscopy analysis. His work has introduced new strategies for engineering long-range ordered low-dimensional ferromagnetism and quantitative observation of interfacial quantum states and atomic dynamics. <br />
                            He has published nearly 80 papers as first or corresponding author in leading journals, with over 17,000 citations and an h-index of 70. He was selected as a Clarivate Highly Cited Researcher and received numerous honors, including the MIT Technology Review TR35 Asia-Pacific 2022, Forbes China 100 Youth Returnee Elite 2022, the Beijing Distinguished Young Scientist Award (2024), and the National Key R&D Program Young Chief Scientist Award (2024).
                        </p>
                    </Col>
                    <Col md={4} xs={12} className="myAvtar">
                        <img src={avatar} className="img-fluid" alt="avatar" />
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className="home-about-social" style={{ marginTop: "2rem" }}>
                        <h3>Google Scholar</h3>
                        <ul className="home-about-social-links">
                            <li className="social-icons">
                                <a
                                    href="https://scholar.google.com/citations?user=ja7lLksAAAAJ"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="icon-colour home-social-icons"
                                >
                                    <img
                                        className="icon-colour home-social-icons"
                                        src={googleScholar}
                                        alt="google scholar"
                                    />
                                </a>
                            </li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default Introduction;
